// extracted by mini-css-extract-plugin
export default {"DepartmentButton":"departmentButton_DepartmentButton__7NUfi","Active":"departmentButton_Active__gtavd"};